import { Clock } from "lucide-react";

export default function LastReviewedBanner({ date, source }) {
  return (
    <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[#9CA3AF] mb-4">
      <Clock className="w-3 h-3" />
      <span>Last reviewed {date}</span>
      {source && <span>· {source}</span>}
    </div>
  );
}
